import { gql } from "@apollo/client";

export const CREATE_CASE_NOTE = gql`
  mutation CreateCaseNote($data: NoteInputData!) {
    createNote(data: $data) {
      id
      createdAt
      updatedAt
      title
      body
      orgId
      caseId
    }
  }
`;
